import React from "react";
import { Grid, InputAdornment, TextField, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import PropTypes from "prop-types";

function ActivityFlexible({ flexibleHours = {}, setFlexibleHours }) {
    const { frequency = "", hours = "", minutes = "" } = flexibleHours;

    const setValueFor = (type) => ({target}) => {
        const value = Number(target.value);
        if (!isNaN(value) && (type !== "minutes" || value < 60)) {
            setFlexibleHours({ ...flexibleHours, [type]: value });
        }
    };

    return (
        <Grid container spacing={3} sx={{ margin: "16px 0 16px -24px" }}>
            <Grid item xs={4} sm={4} md={4}>
                <TextField
                    variant="outlined"
                    id="text-hours"
                    label="Hours"
                    placeholder="Hours"
                    value={hours}
                    onChange={setValueFor("hours")}
                    InputProps={{endAdornment: <InputAdornment position="end">hrs</InputAdornment>}}
                    required
                />
            </Grid>
            <Grid item xs={4} sm={4} md={4}>
                <TextField
                    variant="outlined"
                    id="text-minutes"
                    label="Minutes"
                    placeholder="Minutes"
                    value={minutes}
                    onChange={setValueFor("minutes")}
                    InputProps={{endAdornment: <InputAdornment position="end">mins</InputAdornment>}}
                    required
                />
            </Grid>

            <Grid item xs={4} sm={4} md={4}>
                <TextField
                    variant="outlined"
                    id="text-frequency"
                    label="Frequency"
                    placeholder="Frequency"
                    value={frequency}
                    onChange={setValueFor("frequency")}
                    required
                />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
                <FormGroup>
                    <FormControlLabel control={<Checkbox />} label="Premium" />
                </FormGroup>
            </Grid>
        </Grid>
    );
}

ActivityFlexible.propTypes = {
    flexibleHours: PropTypes.shape({
        frequency: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        hours: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        minutes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    setFlexibleHours: PropTypes.func.isRequired,
};
export default ActivityFlexible;
